export const LoggerStatus = {
  REQUEST: 'LoggerStatus_REQUEST',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  RESET: 'RESET',
};
